import { axiosInstance as axios } from 'src/boot/axios-base'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    IsNumberValid(_, request) {
      return axios
        .post('IsNumberValid', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetAllCountryCode() {
      return axios
        .post('GetAllCountryCode')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取角色与菜单
    GetRoleMenuRelationList({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/GetRoleMenuRelationList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //删除角色信息
    DeleteRoleInfo({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/DeleteRoleInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取用户与角色的关系
    GetUserRoleRelationList({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/GetUserRoleRelationList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //删除用户与角色
    DeleteUserRoleRelation({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/DeleteUserRoleRelation', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //添加或修改用户与角色的关系 一个用户一个角色
    SetUserRoleRelation({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/SetUserRoleRelation', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //後台管理获取用户
    MntGetUserInfo({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/MntGetUserInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取角色数据
    GetRoleInfoList({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/GetRoleInfoList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取菜单信息
    GetMenuInfoList({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/GetMenuInfoList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //添加或修改角色与菜单的关系
    SetRoleMenuRelation({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/SetRoleMenuRelation', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取角色信息
    GetRoleMenuInfo({ rootGetters }, request) {
      return axios
        .post('/api/Permissions/GetRoleMenuInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
